import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import swal from "sweetalert";
import "./CreateBlock.css";
import ReservationSidebar from "../../Commun/ReservationSidebar";
import ReservationHeader from "../../Commun/ReservationHeader";
import MarketPopup from "./Popups/MarketPopup";
import SourcePopup from "./Popups/SourcePopup";
import RateCodePopup from "./Popups/RateCodePopup";
import AccountPopup from "./Popups/AccountPopup";
import ReservationTypePopup from "./Popups/ReservationTypePopup";
import ReservationMethodPopup from "./Popups/ReservationMethodPopup";
import BlockDefinition from "./BlockDefinition";
import RoomDetails from "./RoomDetails";
import CateringDetails from "./CateringDetails";
import { useProperty } from "../../../PropertyContext";
import FullScreenLoader from "../../../BON Frontend/Booking-Form/Common/FullScreenLoader";
import { saveCreateBlock , resetCreateBlockState } from "../../../Redux/Slices/Reservation/Block/Reservationblockslice ";
// ^ Adjust the import path above to match where you place ReservationBlockSlice.js

export const CreateBlock = () => {
  const { selectedProperty } = useProperty();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { loading } = useSelector((state) => state.reservationBlock);

  const [activeLookup, setActiveLookup] = useState(null);

  // ---- Block Definition ----
  const [blockName, setBlockName] = useState("");
  const [blockCode, setBlockCode] = useState("");
  const [blockStatus, setBlockStatus] = useState("TEN");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [nights, setNights] = useState(0);
  const [market, setMarket] = useState("");
  const [source, setSource] = useState("");
  const [account, setAccount] = useState("");
  const [reservationType, setReservationType] = useState("");
  const [inventoryControl, setInventoryControl] = useState("Elastic");
  const blockOwner = "ALL";
  const [decisionDate, setDecisionDate] = useState("");

  // ---- Room Details ----
  const [roomOwner, setRoomOwner] = useState("ALL");
  const [rateCode, setRateCode] = useState("");
  const [rateCodeId, setRateCodeId] = useState(null);
  const [cutoffDate, setCutoffDate] = useState("");
  const [cutoffDays, setCutoffDays] = useState(0);
  const [printRate, setPrintRate] = useState(true);
  const [reservationMethod, setReservationMethod] = useState("");

  // ---- Catering Details ----
  const [cateringOwner, setCateringOwner] = useState("ALL");
  const [onsiteName, setOnsiteName] = useState("");
  const [eventAttendees, setEventAttendees] = useState("");
  const [functionType, setFunctionType] = useState("");
  const [postAs, setPostAs] = useState("");

  const toLocalDateValue = (date) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  const addDays = (dateValue, days) => {
    const [year, month, day] = dateValue.split("-").map(Number);
    const date = new Date(year, month - 1, day);
    date.setDate(date.getDate() + days);
    return toLocalDateValue(date);
  };

  const calculateNights = (from, to) => {
    const [fromYear, fromMonth, fromDay] = from.split("-").map(Number);
    const [toYear, toMonth, toDay] = to.split("-").map(Number);
    return Math.round(
      (Date.UTC(toYear, toMonth - 1, toDay) -
        Date.UTC(fromYear, fromMonth - 1, fromDay)) /
        86400000,
    );
  };

  const handleStartDateChange = (value) => {
    setStartDate(value);
    if (!value || !endDate) return;
    const difference = calculateNights(value, endDate);
    if (difference >= 1) setNights(difference);
    else {
      setNights(1);
      setEndDate(addDays(value, 1));
    }
  };

  const handleEndDateChange = (value) => {
    setEndDate(value);
    if (!value || !startDate) return;
    const difference = calculateNights(startDate, value);
    if (difference >= 1) setNights(difference);
    else {
      setNights(1);
      setEndDate(addDays(startDate, 1));
    }
  };

  const changeNights = (change) => {
    if (nights === 0 && change < 0) return;
    const nextNights = Math.max(1, nights + change);
    const effectiveStart = startDate || toLocalDateValue(new Date());
    setNights(nextNights);
    setStartDate(effectiveStart);
    setEndDate(addDays(effectiveStart, nextNights));
  };

  const closeLookup = () => setActiveLookup(null);
  const selectMarket = (option) => {
    if (!option) return;
    setMarket(option.Code);
    closeLookup();
  };
  const selectSource = (option) => {
    if (!option) return;
    setSource(option.Code);
    closeLookup();
  };
  const selectRateCode = (option) => {
    if (!option) return;
    setRateCode(option.Code);
    setRateCodeId(option.RateCodeID ?? null);
    closeLookup();
  };
  const selectAccount = (option) => {
    if (!option) return;
    setAccount(option.TA_Name);
    closeLookup();
  };
  const selectReservationType = (option) => {
    if (!option) return;
    setReservationType(option.Code);
    closeLookup();
  };
  const selectReservationMethod = (option) => {
    if (!option) return;
    setReservationMethod(option.Code);
    closeLookup();
  };

 const handleSaveAndGoToRoomGrid = async () => {
  const postData = {
    PropertyID: selectedProperty?.PropertyID,
    BlockName: blockName,
    BlockCode: blockCode,
    BlockStatus: blockStatus,
    StartDate: startDate,
    EndDate: endDate,
    Nights: nights,
    MarketCode: market,
    SourceCode: source,
    AccountName: account,
    ReservationType: reservationType,
    InventoryControl: inventoryControl,
    BlockOwner: blockOwner,
    DecisionDate: decisionDate,
    RoomOwner: roomOwner,
    RateCodeID: rateCodeId,
    RateCode: rateCode,
    CutoffDate: cutoffDate,
    CutoffDays: cutoffDays,
    PrintRate: printRate,
    ReservationMethod: reservationMethod,
    CateringOwner: cateringOwner,
    OnsiteName: onsiteName,
    EventAttendees: eventAttendees,
    FunctionType: functionType,
    PostAs: postAs,
  };

  try {
    const response = await dispatch(saveCreateBlock(postData)).unwrap();

    const responseData = response?.data ?? response;
    const result = responseData?.LocalData?.[0];

    const isSuccess =
      result?.Status === 1 ||
      result?.Status === "1" ||
      responseData?.Success === true;

    swal({
      title: isSuccess ? "Success" : "Error",
      text:
        result?.Message ||
        (isSuccess
          ? "Block created successfully."
          : "Something went wrong."),
      icon: isSuccess ? "success" : "error",
    }).then(() => {
      if (isSuccess) {
        dispatch(resetCreateBlockState());
        navigate("/Reservation/RoomGrid");
      }
    });
  } catch (error) {
    console.log("Create Block Error:", error);

    swal({
      title: "Error",
      text:
        typeof error === "string"
          ? error
          : error?.Message ||
            error?.message ||
            "Something went wrong.",
      icon: "error",
    });
  }
};

  return (
    <>
      {loading && (<FullScreenLoader />)}

      <div className="wrapper">
        <ReservationSidebar />
        <div className="main-panel">
          <ReservationHeader />
          <div className="container">
            <div className="page-inner create-block-page">
              <div className="create-block">
                <div className="create-block-scroll">
                  <h1 className="cb-page-title">Create Block</h1>
                  <div className="row">
                    <BlockDefinition
                      blockName={blockName}
                      setBlockName={setBlockName}
                      blockCode={blockCode}
                      setBlockCode={setBlockCode}
                      blockStatus={blockStatus}
                      setBlockStatus={setBlockStatus}
                      startDate={startDate}
                      endDate={endDate}
                      nights={nights}
                      onStartDateChange={handleStartDateChange}
                      onEndDateChange={handleEndDateChange}
                      onNightsChange={changeNights}
                      market={market}
                      setMarket={setMarket}
                      source={source}
                      setSource={setSource}
                      account={account}
                      setAccount={setAccount}
                      reservationType={reservationType}
                      setReservationType={setReservationType}
                      inventoryControl={inventoryControl}
                      setInventoryControl={setInventoryControl}
                      blockOwner={blockOwner}
                      decisionDate={decisionDate}
                      setDecisionDate={setDecisionDate}
                      openLookup={setActiveLookup}
                    />
                    <RoomDetails
                      roomOwner={roomOwner}
                      setRoomOwner={setRoomOwner}
                      rateCode={rateCode}
                      setRateCode={setRateCode}
                      cutoffDate={cutoffDate}
                      setCutoffDate={setCutoffDate}
                      cutoffDays={cutoffDays}
                      setCutoffDays={setCutoffDays}
                      printRate={printRate}
                      setPrintRate={setPrintRate}
                      reservationMethod={reservationMethod}
                      setReservationMethod={setReservationMethod}
                      openLookup={setActiveLookup}
                    />
                    <CateringDetails
                      cateringOwner={cateringOwner}
                      setCateringOwner={setCateringOwner}
                      onsiteName={onsiteName}
                      setOnsiteName={setOnsiteName}
                      eventAttendees={eventAttendees}
                      setEventAttendees={setEventAttendees}
                      functionType={functionType}
                      setFunctionType={setFunctionType}
                      postAs={postAs}
                      setPostAs={setPostAs}
                    />
                  </div>
                </div>

                <div className="page-footer">
                  <span className="footer-copy">
                    © 2024 HospitalityOS Enterprise. All rights reserved.
                  </span>
                  <div className="footer-actions">
                    {/* <button type="button" className="cb-btn cb-btn-cancel">
                      Back
                    </button> */}
                    <button
                      type="button"
                      className="cb-btn cb-btn-save-grid"
                      onClick={handleSaveAndGoToRoomGrid}
                      disabled={loading}
                    >
                      {loading ? "Saving..." : "Save and Go To Room Grid"}
                    </button>
                  </div>
                </div>
              </div>

              <MarketPopup
                show={activeLookup === "market"}
                onClose={closeLookup}
                onSelect={selectMarket}
              />
              <SourcePopup
                show={activeLookup === "source"}
                onClose={closeLookup}
                onSelect={selectSource}
              />
              <RateCodePopup
                show={activeLookup === "rateCode"}
                onClose={closeLookup}
                onSelect={selectRateCode}
              />
              <AccountPopup
                show={activeLookup === "account"}
                onClose={closeLookup}
                onSelect={selectAccount}
              />
              <ReservationTypePopup
                show={activeLookup === "reservationType"}
                onClose={closeLookup}
                onSelect={selectReservationType}
              />
              <ReservationMethodPopup
                show={activeLookup === "reservationMethod"}
                onClose={closeLookup}
                onSelect={selectReservationMethod}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CreateBlock;
